

const inkProfilePhoto = {
  bindings: {
    imageId: '<',
    editable: '<',
    type: '<?',
    size: '<?',
    selectable: '<',
    locked: '<',
    showName: '<',
    showEmailConfirmation: '<',
    profile: '<',
    deletable: '<',
    linkable: '<',
    selected: '<',
    invited: '<',
    rightMargin: '<',
    click: '&',
    onChange: '&'
  },
  controller: 'ProfilePhotoController',
  template: require('./profile-photo.template.html')
};

angular
  .module('inkfinder')
  .component('inkProfilePhoto', inkProfilePhoto);



// WEBPACK FOOTER //
// ./components/collector/profile-photo/profile-photo.component.js